const static_cities = {
  TR: [
    { value: 'Izmir' },
    { value: 'Ankara' },
    { value: 'Antalya' },
    { value: 'Kayseri' },
    { value: 'Tekirdag' },
    { value: 'Adapazari' },
    { value: 'Aydin' },
    { value: 'Mersin' },
    { value: 'Eskisehir' },
    { value: 'Konya' },
    { value: 'Kosekoy' },
    { value: 'Gaziantep' },
    { value: 'Mugla' },
    { value: 'Denizli' },
    { value: 'Istanbul' },
    { value: 'Samsun' },
    { value: 'Diyarbakir' },
    { value: 'Bursa' },
    { value: 'Balikesir' },
    { value: 'Adana' },
    { value: 'Erzurum' },
    { value: 'Antakya' },
    { value: 'Sanliurfa' },
    { value: 'Bolu' },
    { value: 'Afyonkarahisar' },
    { value: 'Mardin' },
    { value: 'Kahramanmaras' },
    { value: 'Corum' },
    { value: 'Magnesia Ad Sipylum' },
    { value: 'Trabzon' },
    { value: 'Sivas' },
    { value: 'Ordu' },
    { value: 'Kirklareli' },
    { value: 'Zonguldak' },
    { value: 'Edirne' },
    { value: 'Van' },
    { value: 'Merkez' },
    { value: 'Rize' },
    { value: 'Kutahya' },
    { value: 'Yalova' },
    { value: 'Batman' },
    { value: 'Isparta' },
    { value: 'Nevsehir' },
    { value: 'Bilecik' },
    { value: 'Atakum' },
    { value: 'Elazig' },
    { value: 'Aksaray' },
    { value: 'Amasya' },
    { value: 'Usak' },
    { value: 'Osmaniye' },
    { value: 'Tokat State' },
    { value: 'Giresun' },
    { value: 'Karabuk' },
    { value: 'Kastamonu' },
    { value: 'Duezce' },
  ],
  IN: [
    { value: 'Hyderabad' },
    { value: 'Kochi' },
    { value: 'Indore' },
    { value: 'Ahmedabad' },
    { value: 'Jaipur' },
    { value: 'Bhopal' },
    { value: 'Guwahati' },
    { value: 'Lucknow' },
    { value: 'Chennai' },
    { value: 'Dehradun' },
    { value: 'Bhubaneswar' },
    { value: 'Kolkata' },
    { value: 'Surat' },
    { value: 'Gurugram' },
    { value: 'Nagpur' },
    { value: 'Ludhiana' },
    { value: 'Chandigarh' },
    { value: 'Patna' },
    { value: 'Mumbai' },
    { value: 'Delhi' },
    { value: 'Pune' },
    { value: 'Bengaluru' },
    { value: 'New Delhi' },
    { value: 'Aizawl' },
    { value: 'Kanpur' },
    { value: 'Kozhikode' },
    { value: 'Sikar' },
    { value: 'Thrissur' },
    { value: 'Raipur' },
    { value: 'Malappuram' },
    { value: 'Rajkot' },
    { value: 'Thane' },
    { value: 'Noida' },
    { value: 'Vadodara' },
    { value: 'Varanasi' },
    { value: 'Coimbatore' },
    { value: 'Jodhpur' },
    { value: 'Thiruvananthapuram' },
    { value: 'Ranchi' },
    { value: 'Meerut' },
    { value: 'Kollam' },
    { value: 'Shimla' },
    { value: 'Palakkad' },
    { value: 'Karnal' },
    { value: 'Ghaziabad' },
    { value: 'Visakhapatnam' },
    { value: 'Sagar' },
    { value: 'Mohali' },
    { value: 'Vijayawada' },
    { value: 'Navi Mumbai' },
  ],
  BR: [
    { value: 'Fortaleza' },
    { value: 'Campinas' },
    { value: 'Natal' },
    { value: 'Betim' },
    { value: 'Porto Alegre' },
    { value: 'Recife' },
    { value: 'Guarulhos' },
    { value: 'Florianopolis' },
    { value: 'Juiz De Fora' },
    { value: 'Uberaba' },
    { value: 'Sao Luis' },
    { value: 'Aracaju' },
    { value: 'Volta Redonda' },
    { value: 'Aparecida De Goiania' },
    { value: 'Curitiba' },
    { value: 'Sao Jose Dos Campos' },
    { value: 'Maceio' },
    { value: 'Blumenau' },
    { value: 'Feira De Santana' },
    { value: 'Jundiai' },
    { value: 'Belo Horizonte' },
    { value: 'Salvador' },
    { value: 'Vitoria' },
    { value: 'Santo Andre' },
    { value: 'Ribeirao Preto' },
    { value: 'Duque De Caxias' },
    { value: 'Sao Bernardo Do Campo' },
    { value: 'Maringa' },
    { value: 'Cuiaba' },
    { value: 'Sao Goncalo' },
    { value: 'Santos' },
    { value: 'Praia Grande' },
    { value: 'Vila Velha' },
    { value: 'Carapicuiba' },
    { value: 'Rio De Janeiro' },
    { value: 'Barueri' },
    { value: 'Manaus' },
    { value: 'Belem' },
    { value: 'Joao Pessoa' },
    { value: 'Porto Velho' },
    { value: 'Suzano' },
    { value: 'Joinville' },
    { value: 'Osasco' },
    { value: 'Serra' },
    { value: 'Canoas' },
    { value: 'Caruaru' },
    { value: 'Sao Vicente' },
    { value: 'Bauru' },
    { value: 'Limeira' },
    { value: 'Niteroi' },
    { value: 'Itaquaquecetuba' },
    { value: 'Uberlandia' },
    { value: 'Itajai' },
    { value: 'Contagem' },
    { value: 'Ponta Grossa' },
    { value: 'Brasilia' },
    { value: 'Nova Iguacu' },
    { value: 'Campo Grande' },
    { value: 'Sorocaba' },
    { value: 'Caxias Do Sul' },
    { value: 'Mogi Das Cruzes' },
    { value: 'Sao Paulo' },
    { value: 'Teresina' },
    { value: 'Londrina' },
    { value: 'Macapa' },
    { value: 'Jaboatao Dos Guararapes' },
    { value: 'Cariacica' },
    { value: 'Cascavel' },
    { value: 'Montes Claros' },
    { value: 'Goiania' },
    { value: 'Sao Jose Do Rio Preto' },
    { value: 'Campina Grande' },
    { value: 'Franca' },
    { value: 'Piracicaba' },
    { value: 'Marilia' },
    { value: 'Vitoria Da Conquista' },
    { value: 'Boa Vista' },
    { value: 'Sinop' },
    { value: 'Aracatuba' },
    { value: 'Cotia' },
    { value: 'Valparaiso De Goias' },
    { value: 'Francisco Morato' },
    { value: 'Macae' },
    { value: 'Sobral' },
    { value: 'Jaragua Do Sul' },
    { value: 'Rondonopolis' },
    { value: 'Itaborai' },
    { value: 'Divinopolis' },
    { value: 'Pelotas' },
    { value: 'Guaruja' },
    { value: 'Viamao' },
    { value: 'Arapiraca' },
    { value: 'Botucatu' },
    { value: 'Petropolis' },
    { value: 'Joao Monlevade' },
    { value: 'Atibaia' },
    { value: 'Ipatinga' },
    { value: 'Olinda' },
    { value: 'Nova Friburgo' },
    { value: 'Itabuna' },
    { value: 'Sao Jose' },
    { value: 'Gravatai' },
    { value: 'Petrolina' },
    { value: 'Imperatriz' },
    { value: 'Balneario Camboriu' },
    { value: 'Camacari' },
    { value: 'Sao Joao De Meriti' },
    { value: 'Rio Grande' },
    { value: 'Colombo' },
    { value: 'Aguas Lindas De Goias' },
    { value: 'Dourados' },
    { value: 'Lages' },
    { value: 'Sumare' },
    { value: 'Taboao Da Serra' },
    { value: 'Cabo Frio' },
    { value: 'Novo Hamburgo' },
    { value: 'Marica' },
    { value: 'Sao Leopoldo' },
    { value: 'Itanhaem' },
    { value: 'Chapeco' },
    { value: 'Anapolis' },
    { value: 'Hortolandia' },
    { value: 'Ribeirao Das Neves' },
    { value: 'Santa Maria' },
    { value: 'Mossoro' },
    { value: 'Diadema' },
    { value: 'Cachoeiro De Itapemirim' },
    { value: 'Passo Fundo' },
    { value: 'Paulista' },
    { value: 'Maua' },
    { value: 'Juazeiro Do Norte' },
    { value: 'Americana' },
    { value: 'Presidente Prudente' },
    { value: 'Criciuma' },
    { value: 'Taubate' },
    { value: 'Alvorada' },
    { value: 'Santarem' },
    { value: 'Sao Carlos' },
    { value: 'Indaiatuba' },
    { value: 'Governador Valadares' },
    { value: 'Araraquara' },
    { value: 'Rio Claro' },
    { value: 'Ananindeua' },
    { value: 'Belford Roxo' },
    { value: 'Sao Jose Dos Pinhais' },
    { value: 'Ourinhos' },
    { value: 'Pocos De Caldas' },
    { value: 'Rio Branco' },
    { value: 'Santa Luzia' },
    { value: 'Sete Lagoas' },
    { value: 'Palmas' },
    { value: 'Campos Dos Goytacazes' },
    { value: 'Parnamirim' },
    { value: 'Caraguatatuba' },
    { value: 'Parauapebas' },
    { value: 'Palhoca' },
    { value: 'Foz Do Iguacu' },
    { value: 'Camaragibe' },
    { value: 'Nilopolis' },
    { value: 'Varzea Paulista' },
    { value: 'Patos De Minas' },
    { value: 'Rio Do Sul' },
    { value: 'Linhares' },
    { value: 'Castanhal' },
    { value: 'Porto Seguro' },
    { value: 'Araguaina' },
    { value: 'Jacarei' },
    { value: 'Maraba' },
    { value: 'Angra Dos Reis' },
    { value: 'Barra Mansa' },
    { value: 'Catanduva' },
    { value: 'Guaratingueta' },
    { value: 'Teixeira De Freitas' },
    { value: 'Tatui' },
    { value: 'Itapevi' },
    { value: 'Catalao' },
    { value: 'Queimados' },
    { value: 'Tubarao' },
    { value: 'Valinhos' },
    { value: 'Varginha' },
    { value: 'Caucaia' },
    { value: 'Paranagua' },
    { value: 'Pindamonhangaba' },
    { value: 'Campo Largo' },
    { value: 'Fazenda Rio Grande' },
    { value: 'Maracanau' },
    { value: 'Jau' },
    { value: 'Luziania' },
    { value: 'Franco Da Rocha' },
    { value: 'Parnaiba' },
    { value: 'Embu' },
    { value: 'Santa Cruz Do Sul' },
    { value: 'Braganca Paulista' },
    { value: 'Pouso Alegre' },
    { value: 'Mage' },
    { value: 'Garanhuns' },
    { value: 'Guarapuava' },
    { value: 'Vitoria De Santo Antao' },
  ],
  LT: [
    { value: 'Vilnius' },
    { value: 'Kaunas' },
    { value: 'Klaipeda' },
    { value: 'Siauliai' },
  ],
  DO: [
    { value: 'Santo Domingo' },
    { value: 'Santiago De Los Caballeros' },
    { value: 'Santo Domingo Este' },
  ],
  UY: [{ value: 'Montevideo' }, { value: 'Maldonado' }],
  GT: [{ value: 'Guatemala City' }],
  MX: [
    { value: 'Tijuana' },
    { value: 'Puebla City' },
    { value: 'Culiacan' },
    { value: 'Guadalajara' },
    { value: 'Gustavo Adolfo Madero' },
    { value: 'Zapopan' },
    { value: 'Mexicali' },
    { value: 'Hermosillo' },
    { value: 'Mexico City' },
    { value: 'Ciudad Juarez' },
    { value: 'Monterrey' },
    { value: 'Toluca' },
    { value: 'Veracruz' },
    { value: 'Chihuahua City' },
    { value: 'Queretaro City' },
    { value: 'Iztapalapa' },
    { value: 'Ciudad Nezahualcoyotl' },
    { value: 'Merida' },
    { value: 'Tuxtla Gutierrez' },
    { value: 'Saltillo' },
    { value: 'Leon' },
    { value: 'Acapulco De Juarez' },
    { value: 'Reynosa' },
    { value: 'Ciudad Obregon' },
    { value: 'Durango' },
    { value: 'Xalapa' },
    { value: 'Tampico' },
    { value: 'Guadalupe' },
    { value: 'San Luis Potosi City' },
    { value: 'Pachuca' },
    { value: 'Morelia' },
    { value: 'Centro' },
    { value: 'Aguascalientes' },
    { value: 'Oaxaca City' },
    { value: 'Naucalpan' },
    { value: 'Ecatepec' },
    { value: 'Apodaca' },
    { value: 'Juarez' },
    { value: 'Torreon' },
    { value: 'Cuautitlan Izcalli' },
    { value: 'Cuernavaca' },
    { value: 'Tepic' },
    { value: 'Azcapotzalco' },
    { value: 'Tlaxcala City' },
    { value: 'Mazatlan' },
    { value: 'Tlalnepantla' },
    { value: 'Ensenada' },
    { value: 'Nogales' },
    { value: 'Venustiano Carranza' },
    { value: 'Campeche' },
  ],
  DE: [
    { value: 'Berlin' },
    { value: 'Hamburg' },
    { value: 'Cologne' },
    { value: 'Munich' },
    { value: 'Frankfurt Am Main' },
    { value: 'Essen' },
    { value: 'Dusseldorf' },
    { value: 'Hanover' },
    { value: 'Dortmund' },
    { value: 'Stuttgart' },
    { value: 'Duisburg' },
    { value: 'Dresden' },
    { value: 'Nuremberg' },
    { value: 'Leipzig' },
    { value: 'Wuppertal' },
    { value: 'Bremen' },
    { value: 'Mannheim' },
    { value: 'Karlsruhe' },
    { value: 'Bochum' },
  ],
  LK: [{ value: 'Colombo' }],
  US: [
    { value: 'New York' },
    { value: 'Los Angeles' },
    { value: 'Chicago' },
    { value: 'Houston' },
    { value: 'Miami' },
    { value: 'Seattle' },
    { value: 'Newark' },
    { value: 'Denver' },
    { value: 'San Diego' },
    { value: 'Indianapolis' },
    { value: 'Washington' },
    { value: 'Fort Worth' },
    { value: 'Philadelphia' },
    { value: 'San Antonio' },
    { value: 'Atlanta' },
    { value: 'Sacramento' },
    { value: 'Minneapolis' },
    { value: 'Louisville' },
    { value: 'Detroit' },
    { value: 'Richmond' },
    { value: 'Queens' },
    { value: 'Phoenix' },
    { value: 'Dallas' },
    { value: 'Portland' },
    { value: 'Tampa' },
    { value: 'San Jose' },
    { value: 'Las Vegas' },
    { value: 'Charlotte' },
    { value: 'Austin' },
    { value: 'Springfield' },
    { value: 'Orlando' },
    { value: 'Jacksonville' },
    { value: 'Brooklyn' },
    { value: 'Columbus' },
    { value: 'The Bronx' },
    { value: 'Arlington' },
    { value: 'Memphis' },
    { value: 'Hialeah' },
    { value: 'Columbia' },
    { value: 'Nashville' },
    { value: 'Fayetteville' },
    { value: 'Baltimore' },
    { value: 'Wilmington' },
    { value: 'Lancaster' },
    { value: 'Fresno' },
    { value: 'Aurora' },
    { value: 'Boston' },
    { value: 'Tucson' },
    { value: 'Fort Lauderdale' },
    { value: 'Wichita' },
    { value: 'Katy' },
    { value: 'Mesa' },
    { value: 'Knoxville' },
    { value: 'Bakersfield' },
    { value: 'Birmingham' },
    { value: 'Greenville' },
    { value: 'Lincoln' },
    { value: 'Tacoma' },
    { value: 'Virginia Beach' },
    { value: 'Staten Island' },
    { value: 'Spokane' },
    { value: 'Omaha' },
    { value: 'Riverside' },
    { value: 'Raleigh' },
    { value: 'Lafayette' },
    { value: 'Rochester' },
    { value: 'Lexington' },
    { value: 'Henderson' },
    { value: 'Dayton' },
    { value: 'Kissimmee' },
    { value: 'Spring' },
    { value: 'Pittsburgh' },
    { value: 'Kansas City' },
    { value: 'Albuquerque' },
    { value: 'El Paso' },
    { value: 'Saint Paul' },
    { value: 'Buffalo' },
    { value: 'Cincinnati' },
    { value: 'Greensboro' },
    { value: 'Vancouver' },
    { value: 'St Louis' },
    { value: 'Oklahoma City' },
    { value: 'Milwaukee' },
    { value: 'Tappahannock' },
    { value: 'Cleveland' },
    { value: 'San Francisco' },
    { value: 'Oakland' },
    { value: 'Gainesville' },
    { value: 'Colorado Springs' },
    { value: 'Salt Lake City' },
    { value: 'Stockton' },
    { value: 'Silver Spring' },
    { value: 'Providence' },
    { value: 'Fort Wayne' },
    { value: 'Tallahassee' },
    { value: 'Plano' },
    { value: 'Glendale' },
    { value: 'Long Beach' },
    { value: 'Concord' },
    { value: 'Honolulu' },
    { value: 'Tulsa' },
    { value: 'Canton' },
    { value: 'Reno' },
    { value: 'Athens' },
    { value: 'Hollywood' },
    { value: 'Fontana' },
    { value: 'Montgomery' },
    { value: 'Chandler' },
    { value: 'Akron' },
    { value: 'Naples' },
    { value: 'Albany' },
    { value: 'Charleston' },
    { value: 'Irvine' },
    { value: 'Marietta' },
    { value: 'Grand Rapids' },
    { value: 'Lawrenceville' },
    { value: 'New Orleans' },
    { value: 'Auburn' },
    { value: 'Woodbridge' },
    { value: 'Jackson' },
    { value: 'Alexandria' },
    { value: 'Baton Rouge' },
    { value: 'Lakeland' },
    { value: 'Peoria' },
    { value: 'Fredericksburg' },
    { value: 'Madison' },
    { value: 'Boise' },
    { value: 'Monroe' },
    { value: 'Bloomington' },
    { value: 'Lake Worth' },
    { value: 'Decatur' },
    { value: 'West Palm Beach' },
  ],
  PL: [
    { value: 'Katowice' },
    { value: 'Warsaw' },
    { value: 'Krakow' },
    { value: 'Wroclaw' },
    { value: 'Lublin' },
    { value: 'Szczecin' },
    { value: 'Lodz' },
    { value: 'Gdynia' },
    { value: 'Poznan' },
    { value: 'Gdansk' },
    { value: 'Bydgoszcz' },
    { value: 'Rzeszow' },
    { value: 'Bialystok' },
    { value: 'Zielona Gora' },
    { value: 'Olsztyn' },
    { value: 'Zabrze' },
    { value: 'Gliwice' },
    { value: 'Kielce' },
  ],
  EE: [{ value: 'Tallinn' }],
  AR: [
    { value: 'Salta' },
    { value: 'Quilmes' },
    { value: 'Cordoba' },
    { value: 'Lanus' },
    { value: 'San Miguel De Tucuman' },
    { value: 'Mendoza' },
    { value: 'Buenos Aires' },
    { value: 'Mar Del Plata' },
    { value: 'Corrientes' },
    { value: 'La Plata' },
    { value: 'Rosario' },
    { value: 'Avellaneda' },
    { value: 'San Luis' },
    { value: 'Ituzaingo' },
    { value: 'Berazategui' },
    { value: 'Formosa' },
    { value: 'Parana' },
    { value: 'Merlo' },
    { value: 'Neuquen' },
    { value: 'Pilar' },
    { value: 'Florencio Varela' },
    { value: 'Moreno' },
    { value: 'Monte Grande' },
    { value: 'Bahia Blanca' },
    { value: 'Moron' },
    { value: 'San Juan' },
    { value: 'San Miguel' },
    { value: 'Jose C Paz' },
    { value: 'Villa Ballester' },
    { value: 'Caseros' },
    { value: 'Resistencia' },
    { value: 'Hurlingham' },
    { value: 'Lomas De Zamora' },
    { value: 'San Salvador De Jujuy' },
    { value: 'Isidro Casanova' },
    { value: 'Posadas' },
    { value: 'Santa Fe' },
    { value: 'La Rioja' },
    { value: 'Comodoro Rivadavia' },
    { value: 'Rio Gallegos' },
    { value: 'San Fernando' },
    { value: 'Jose Maria Ezeiza' },
    { value: 'Laferrere' },
    { value: 'Rio Cuarto' },
    { value: 'San Justo' },
    { value: 'Catamarca' },
  ],
  SA: [
    { value: 'Dammam' },
    { value: 'Jeddah' },
    { value: 'Riyadh' },
    { value: 'Medina' },
    { value: 'Al Qatif' },
  ],
  IT: [
    { value: 'Turin' },
    { value: 'Rome' },
    { value: 'Milan' },
    { value: 'Naples' },
    { value: 'Bologna' },
    { value: 'Catania' },
    { value: 'Padova' },
    { value: 'Palermo' },
    { value: 'Bari' },
    { value: 'Florence' },
    { value: 'Verona' },
    { value: 'Genoa' },
    { value: 'Brescia' },
    { value: 'Cagliari' },
    { value: 'Pescara' },
  ],
  UZ: [{ value: 'Samarkand' }, { value: 'Tashkent' }, { value: 'Bukhara' }],
  IL: [
    { value: 'Jerusalem' },
    { value: 'Tel Aviv' },
    { value: 'Rishon Letsiyyon' },
    { value: 'Haifa' },
    { value: 'Petah Tikva' },
    { value: 'Ramat Gan' },
    { value: 'Holon' },
  ],
  FR: [
    { value: 'Marseille' },
    { value: 'Lyon' },
    { value: 'Toulouse' },
    { value: 'Paris' },
    { value: 'Rennes' },
    { value: 'Nantes' },
    { value: 'Bordeaux' },
    { value: 'Lille' },
    { value: 'Montpellier' },
    { value: 'Strasbourg' },
    { value: 'Nice' },
    { value: 'Angers' },
    { value: 'Le Mans' },
    { value: 'Rouen' },
  ],
  VN: [
    { value: 'Ho Chi Minh City' },
    { value: 'Hanoi' },
    { value: 'Da Nang' },
    { value: 'Bien Hoa' },
    { value: 'Can Tho' },
    { value: 'Haiphong' },
    { value: 'Nha Trang' },
  ],
  MA: [
    { value: 'Casablanca' },
    { value: 'Marrakesh' },
    { value: 'Rabat' },
    { value: 'Meknes' },
    { value: 'Fes' },
    { value: 'Agadir' },
    { value: 'Tangier' },
    { value: 'Sale' },
    { value: 'Oujda' },
    { value: 'Kenitra' },
    { value: 'Tetouan' },
    { value: 'El Jadida' },
    { value: 'Beni Mellal' },
  ],
  AT: [{ value: 'Vienna' }, { value: 'Graz' }],
  SV: [{ value: 'San Salvador' }],
  CR: [{ value: 'San Jose' }, { value: 'Heredia' }, { value: 'Alajuela' }],
  CA: [
    { value: 'Calgary' },
    { value: 'Surrey' },
    { value: 'Toronto' },
    { value: 'Vancouver' },
    { value: 'Edmonton' },
    { value: 'Montreal' },
    { value: 'Winnipeg' },
    { value: 'Regina' },
    { value: 'Victoria' },
    { value: 'Hamilton' },
    { value: 'Scarborough' },
    { value: 'Saskatoon' },
    { value: 'Longueuil' },
    { value: 'Ottawa' },
    { value: 'Laval' },
    { value: 'Brampton' },
    { value: 'Quebec' },
    { value: 'Mississauga' },
    { value: 'Burnaby' },
    { value: 'Windsor' },
    { value: 'Kitchener' },
    { value: 'Gatineau' },
  ],
  SK: [{ value: 'Bratislava' }, { value: 'Kosice' }, { value: 'Nitra' }],
  PH: [
    { value: 'Mabalacat' },
    { value: 'Paranaque City' },
    { value: 'Manila' },
    { value: 'Batangas' },
    { value: 'Baguio City' },
    { value: 'Taguig' },
    { value: 'Cebu City' },
    { value: 'General Trias' },
    { value: 'Dasmarinas' },
    { value: 'Marikina City' },
    { value: 'Quezon City' },
    { value: 'Davao City' },
    { value: 'Bacolod City' },
    { value: 'Cabanatuan City' },
    { value: 'Iloilo City' },
    { value: 'Tarlac City' },
    { value: 'Talavera' },
    { value: 'Mandaluyong City' },
    { value: 'Bacoor' },
    { value: 'Cagayan De Oro' },
    { value: 'Lahug' },
    { value: 'Caloocan City' },
    { value: 'Makati City' },
    { value: 'Lucena City' },
    { value: 'Antipolo City' },
    { value: 'Tanza' },
    { value: 'Zamboanga City' },
    { value: 'Malabon' },
    { value: 'San Jose Del Monte' },
    { value: 'Las Pinas' },
    { value: 'Imus' },
    { value: 'Butuan' },
    { value: 'Urdaneta' },
    { value: 'Calamba' },
    { value: 'Tuguegarao City' },
    { value: 'Lipa City' },
    { value: 'Olongapo City' },
    { value: 'Cabuyao' },
    { value: 'City Of Muntinlupa' },
    { value: 'San Pedro' },
    { value: 'Carmona' },
    { value: 'Angeles City' },
    { value: 'San Pablo City' },
    { value: 'Nasugbu' },
    { value: 'Santa Rosa' },
    { value: 'Naga' },
    { value: 'Dagupan' },
    { value: 'Iligan' },
  ],
  ES: [
    { value: 'Valencia' },
    { value: 'Seville' },
    { value: 'Madrid' },
    { value: 'Barcelona' },
    { value: 'Malaga' },
    { value: 'Bilbao' },
    { value: 'Vigo' },
    { value: 'Murcia' },
    { value: 'Valladolid' },
    { value: 'A Coruna' },
    { value: 'Palma' },
    { value: 'Santa Cruz De Tenerife' },
    { value: 'Alicante' },
    { value: 'Terrassa' },
    { value: 'Gijon' },
    { value: 'Zaragoza' },
    { value: 'Granada' },
    { value: 'Las Palmas De Gran Canaria' },
  ],
  SN: [{ value: 'Dakar' }],
  RO: [
    { value: 'Cluj Napoca' },
    { value: 'Iasi' },
    { value: 'Timisoara' },
    { value: 'Bucharest' },
    { value: 'Craiova' },
    { value: 'Arad' },
    { value: 'Galati' },
    { value: 'Brasov' },
    { value: 'Oradea' },
    { value: 'Ploiesti' },
    { value: 'Constanta' },
    { value: 'Pitesti' },
    { value: 'Sibiu' },
  ],
  CY: [{ value: 'Nicosia' }, { value: 'Limassol' }],
  JM: [{ value: 'Kingston' }, { value: 'Montego Bay' }],
  MN: [{ value: 'Ulan Bator' }],
  CO: [
    { value: 'Barranquilla' },
    { value: 'Bogota' },
    { value: 'Santiago De Cali' },
    { value: 'Bucaramanga' },
    { value: 'Medellin' },
    { value: 'Cartagena' },
    { value: 'Cucuta' },
    { value: 'Neiva' },
    { value: 'Ibague' },
    { value: 'Pereira' },
    { value: 'Pasto' },
    { value: 'Manizales' },
    { value: 'Santa Marta' },
    { value: 'Villavicencio' },
    { value: 'Valledupar' },
    { value: 'Chia' },
    { value: 'Tunja' },
    { value: 'Popayan' },
  ],
  PE: [
    { value: 'Trujillo' },
    { value: 'Lima' },
    { value: 'Arequipa' },
    { value: 'Piura' },
    { value: 'Cusco' },
    { value: 'Huancayo' },
    { value: 'Tacna' },
    { value: 'Chiclayo' },
    { value: 'Chimbote' },
    { value: 'Ica' },
    { value: 'Huanuco' },
    { value: 'Pucallpa' },
  ],
  MD: [{ value: 'Chisinau' }],
  BO: [{ value: 'Santa Cruz' }, { value: 'La Paz' }, { value: 'Cochabamba' }],
  AE: [
    { value: 'Dubai' },
    { value: 'Sharjah' },
    { value: 'Abu Dhabi' },
    { value: 'Ajman' },
    { value: 'Ras Al Khaimah' },
    { value: 'Al Ain City' },
  ],
  QA: [{ value: 'Doha' }],
  RU: [
    { value: 'Moscow' },
    { value: 'St Petersburg' },
    { value: 'Kazan' },
    { value: 'Perm' },
    { value: 'Nizhniy Novgorod' },
    { value: 'Voronezh' },
    { value: 'Samara' },
    { value: 'Ufa' },
    { value: 'Yekaterinburg' },
    { value: 'Rostov On Don' },
    { value: 'Krasnodar' },
    { value: 'Novosibirsk' },
    { value: 'Chelyabinsk' },
  ],
  HN: [{ value: 'Tegucigalpa' }, { value: 'San Pedro Sula' }],
  MY: [
    { value: 'Kota Kinabalu' },
    { value: 'Petaling Jaya' },
    { value: 'Kuching' },
    { value: 'Kuala Lumpur' },
    { value: 'George Town' },
    { value: 'Shah Alam' },
    { value: 'Johor Bahru' },
    { value: 'Puchong Batu Dua Belas' },
    { value: 'Ipoh' },
  ],
  CZ: [
    { value: 'Brno' },
    { value: 'Prague' },
    { value: 'Ostrava' },
    { value: 'Olomouc' },
  ],
  KG: [{ value: 'Bishkek' }],
  AU: [
    { value: 'Adelaide' },
    { value: 'Melbourne' },
    { value: 'Sydney' },
    { value: 'Brisbane' },
    { value: 'Perth' },
  ],
  SE: [{ value: 'Gothenburg' }, { value: 'Stockholm' }, { value: 'Malmo' }],
  GE: [{ value: 'Tbilisi' }, { value: 'Batumi' }, { value: 'Kutaisi' }],
  ID: [
    { value: 'Semarang' },
    { value: 'Medan' },
    { value: 'Malang' },
    { value: 'Jakarta' },
    { value: 'Tangerang' },
    { value: 'Bogor' },
    { value: 'Bandung' },
    { value: 'Yogyakarta' },
    { value: 'Makassar' },
    { value: 'Surabaya' },
    { value: 'Bekasi' },
    { value: 'Denpasar' },
    { value: 'Pekanbaru' },
    { value: 'South Tangerang' },
    { value: 'Magelang' },
    { value: 'Kediri' },
    { value: 'Pontianak' },
    { value: 'Manado' },
    { value: 'Banjarmasin' },
    { value: 'Sidoarjo' },
    { value: 'Balikpapan' },
    { value: 'Palembang' },
    { value: 'Surakarta' },
    { value: 'Batam' },
    { value: 'Tasikmalaya' },
    { value: 'Depok' },
    { value: 'Cirebon' },
    { value: 'Bandar Lampung' },
    { value: 'Jember' },
    { value: 'Samarinda' },
  ],
  OM: [{ value: 'Muscat' }],
  TW: [
    { value: 'Taoyuan District' },
    { value: 'Kaohsiung City' },
    { value: 'New Taipei' },
    { value: 'Tainan City' },
    { value: 'Taipei' },
    { value: 'Taichung' },
    { value: 'Hsinchu' },
    { value: 'Zhongli District' },
    { value: 'Chang Hua' },
  ],
  HK: [{ value: 'Central' }],
  PT: [
    { value: 'Lisbon' },
    { value: 'Porto' },
    { value: 'Coimbra' },
    { value: 'Braga' },
    { value: 'Funchal' },
    { value: 'Vila Nova De Gaia' },
    { value: 'Amadora' },
    { value: 'Setubal' },
    { value: 'Almada' },
  ],
  NL: [
    { value: 'Amsterdam' },
    { value: 'Rotterdam' },
    { value: 'The Hague' },
    { value: 'Almere Stad' },
    { value: 'Naaldwijk' },
  ],
  DZ: [
    { value: 'Oran' },
    { value: 'Algiers' },
    { value: 'Tlemcen' },
    { value: 'Batna City' },
    { value: 'Blida' },
    { value: 'Bejaia' },
    { value: 'Constantine' },
    { value: 'Skikda' },
    { value: 'Setif' },
    { value: 'Djelfa' },
  ],
  ZA: [
    { value: 'Johannesburg' },
    { value: 'Pretoria' },
    { value: 'Durban' },
    { value: 'Cape Town' },
    { value: 'Port Elizabeth' },
    { value: 'Bloemfontein' },
    { value: 'Centurion' },
    { value: 'Boksburg' },
  ],
  EG: [
    { value: 'Tanta' },
    { value: 'Al Mansurah' },
    { value: 'Giza' },
    { value: 'Cairo' },
    { value: 'Alexandria' },
    { value: 'Asyut' },
    { value: 'Zagazig' },
    { value: 'Ismailia' },
    { value: 'Port Said' },
    { value: 'Damietta' },
  ],
  AO: [{ value: 'Luanda' }],
  GB: [
    { value: 'London' },
    { value: 'Manchester' },
    { value: 'Glasgow' },
    { value: 'Birmingham' },
    { value: 'Southampton' },
    { value: 'Leicester' },
    { value: 'Cardiff' },
    { value: 'Liverpool' },
    { value: 'Sheffield' },
    { value: 'Coventry' },
    { value: 'Hull' },
    { value: 'Croydon' },
    { value: 'Hackney' },
    { value: 'Derby' },
    { value: 'Nottingham' },
    { value: 'Bristol' },
    { value: 'Edinburgh' },
    { value: 'Reading' },
    { value: 'Ilford' },
    { value: 'Leeds' },
    { value: 'Newcastle Upon Tyne' },
    { value: 'Southwark' },
    { value: 'Slough' },
    { value: 'Islington' },
    { value: 'Belfast' },
    { value: 'Bradford' },
    { value: 'Wolverhampton' },
    { value: 'Northampton' },
    { value: 'Stoke On Trent' },
    { value: 'Plymouth' },
    { value: 'Milton Keynes' },
    { value: 'Norwich' },
  ],
  TN: [
    { value: 'Tunis' },
    { value: 'Aryanah' },
    { value: 'Bizerte' },
    { value: 'Sousse' },
    { value: 'Sfax' },
  ],
  XK: [{ value: 'Pristina' }],
  UA: [
    { value: 'Odesa' },
    { value: 'Kyiv' },
    { value: 'Dnipro' },
    { value: 'Lviv' },
    { value: 'Ternopil' },
    { value: 'Zaporizhzhya' },
    { value: 'Vinnytsia' },
    { value: 'Kryvyi Rih' },
    { value: 'Kharkiv' },
    { value: 'Chernivtsi' },
    { value: 'Poltava' },
    { value: 'Mykolayiv' },
    { value: 'Cherkasy' },
    { value: 'Khmelnytskyi' },
  ],
  VE: [
    { value: 'Maracaibo' },
    { value: 'Caracas' },
    { value: 'Ciudad Guayana' },
    { value: 'Maracay' },
    { value: 'Valencia' },
    { value: 'Barquisimeto' },
  ],
  TH: [{ value: 'Bangkok' }, { value: 'Chiang Mai' }, { value: 'Khon Kaen' }],
  NP: [
    { value: 'Kathmandu' },
    { value: 'Patan' },
    { value: 'Biratnagar' },
    { value: 'Ilam' },
    { value: 'Kaski' },
    { value: 'Bharatpur' },
  ],
  CL: [
    { value: 'Concepcion' },
    { value: 'Antofagasta' },
    { value: 'Santiago' },
    { value: 'Port Montt' },
    { value: 'Rancagua' },
    { value: 'Arica' },
    { value: 'Vina Del Mar' },
    { value: 'Temuco' },
    { value: 'Valparaiso' },
    { value: 'Iquique' },
    { value: 'La Serena' },
    { value: 'Talca' },
  ],
  BH: [{ value: 'Manama' }],
  BG: [
    { value: 'Plovdiv' },
    { value: 'Varna' },
    { value: 'Sofia' },
    { value: 'Burgas' },
    { value: 'Rousse' },
    { value: 'Stara Zagora' },
  ],
  GR: [{ value: 'Athens' }, { value: 'Thessaloniki' }],
  KW: [{ value: 'Kuwait City' }],
  JO: [{ value: 'Amman' }],
  BE: [
    { value: 'Brussels' },
    { value: 'Antwerp' },
    { value: 'Ghent' },
    { value: 'Liege' },
  ],
  PK: [
    { value: 'Islamabad' },
    { value: 'Lahore' },
    { value: 'Rawalpindi' },
    { value: 'Karachi' },
    { value: 'Peshawar' },
    { value: 'Muzaffargarh' },
    { value: 'Gujranwala' },
    { value: 'Faisalabad' },
    { value: 'Multan' },
  ],
  JP: [{ value: 'Tokyo' }, { value: 'Yokohama' }, { value: 'Umeda' }],
  CH: [
    { value: 'Zurich' },
    { value: 'Lausanne' },
    { value: 'Geneva' },
    { value: 'Bern' },
  ],
  KH: [{ value: 'Phnom Penh' }],
  ZM: [{ value: 'Lusaka' }],
  TG: [{ value: 'Lome' }],
  BD: [{ value: 'Dhaka' }, { value: 'Chittagong' }, { value: 'Rajshahi' }],
  PA: [{ value: 'Panama City' }],
  BY: [
    { value: 'Minsk' },
    { value: 'Hrodna' },
    { value: 'Gomel' },
    { value: 'Brest' },
  ],
  NO: [{ value: 'Oslo' }],
  CI: [{ value: 'Abidjan' }],
  EC: [
    { value: 'Quito' },
    { value: 'Guayaquil' },
    { value: 'Cuenca' },
    { value: 'Ambato' },
    { value: 'Machala' },
    { value: 'Portoviejo' },
    { value: 'Loja' },
  ],
  FI: [{ value: 'Helsinki' }, { value: 'Tampere' }, { value: 'Espoo' }],
  PY: [{ value: 'Asuncion' }, { value: 'Ciudad Del Este' }],
  NG: [
    { value: 'Lagos' },
    { value: 'Port Harcourt' },
    { value: 'Katsina' },
    { value: 'Abuja' },
  ],
  RS: [{ value: 'Novi Sad' }, { value: 'Belgrade' }, { value: 'Nis' }],
  IE: [{ value: 'Dublin' }],
  AL: [{ value: 'Tirana' }],
  HR: [{ value: 'Zagreb' }, { value: 'Split' }],
  MK: [{ value: 'Skopje' }],
  HU: [
    { value: 'Budapest' },
    { value: 'Miskolc' },
    { value: 'Szeged' },
    { value: 'Szekesfehervar' },
    { value: 'Debrecen' },
    { value: 'Pecs' },
    { value: 'Kecskemet' },
  ],
  KE: [{ value: 'Nairobi' }],
  NZ: [
    { value: 'Auckland' },
    { value: 'Wellington' },
    { value: 'Christchurch' },
    { value: 'Hamilton' },
  ],
  KR: [
    { value: 'Seoul' },
    { value: 'Suwon' },
    { value: 'Gwanak Gu' },
    { value: 'Buk Gu' },
    { value: 'Seongnam Si' },
    { value: 'Gangnam Gu' },
    { value: 'Seo Gu' },
    { value: 'Goyang Si' },
    { value: 'Incheon' },
    { value: 'Yongin Si' },
  ],
  SI: [{ value: 'Ljubljana' }, { value: 'Maribor' }],
  AM: [{ value: 'Yerevan' }],
  AZ: [{ value: 'Baku' }],
  LV: [{ value: 'Riga' }],
  ET: [{ value: 'Addis Ababa' }],
  IR: [{ value: 'Tehran' }],
  TT: [{ value: 'Port Of Spain' }, { value: 'Chaguanas' }],
  NI: [{ value: 'Managua' }],
  GH: [{ value: 'Accra' }],
  BA: [{ value: 'Sarajevo' }, { value: 'Banja Luka' }, { value: 'Tuzla' }],
  NA: [{ value: 'Windhoek' }],
  BS: [{ value: 'Nassau' }],
  CW: [{ value: 'Willemstad' }],
  ZW: [{ value: 'Harare' }],
  PR: [{ value: 'San Juan' }],
  CN: [{ value: 'Shanghai' }, { value: 'Shenzhen' }, { value: 'Guangzhou' }],
  HT: [{ value: 'Port Au Prince' }],
  BW: [{ value: 'Gaborone' }],
  GY: [{ value: 'Georgetown' }],
  LB: [{ value: 'Beirut' }],
  MU: [{ value: 'Port Louis' }],
  SR: [{ value: 'Paramaribo' }],
  MV: [{ value: 'Male' }],
  MO: [{ value: 'Macao' }],
  KZ: [{ value: 'Astana' }, { value: 'Almaty' }],
  MZ: [{ value: 'Maputo' }],
  GA: [{ value: 'Libreville' }],
  IQ: [{ value: 'Erbil' }, { value: 'Baghdad' }],
  RW: [{ value: 'Kigali' }],
  DK: [{ value: 'Copenhagen' }],
  IS: [{ value: 'Reykjavik' }],
  BB: [{ value: 'Bridgetown' }],
  ME: [{ value: 'Podgorica' }],
  LA: [{ value: 'Vientiane' }],
  UG: [{ value: 'Kampala' }],
  LC: [{ value: 'Castries' }],
  MM: [{ value: 'Yangon' }],
  MG: [{ value: 'Antananarivo' }],
  DM: [{ value: 'Roseau' }],
  LU: [{ value: 'Luxembourg' }],
  YE: [{ value: 'Sanaa' }],
  BN: [{ value: 'Bandar Seri Begawan' }],
  CU: [{ value: 'Havana' }],
  TZ: [{ value: 'Dar Es Salaam' }],
};

export default static_cities;
